var React = require('react');

function GoogleIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.127 7.218v3.564s3.506-.005 4.934-.005c-.774 2.311-1.976 3.57-4.934 3.57-2.995 0-5.332-2.394-5.332-5.347 0-2.953 2.337-5.347 5.332-5.347 1.583 0 2.605.55 3.543 1.314.75-.74.688-.846 2.598-2.625A9.164 9.164 0 009.127 0C4.087 0 0 4.03 0 9s4.087 9 9.127 9c7.533 0 9.375-6.47 8.765-10.782H9.127","fill":"#DB5340","fillRule":"evenodd"}));
}

GoogleIconInline.defaultProps = {"width":"18","height":"18"};

module.exports = GoogleIconInline;

GoogleIconInline.default = GoogleIconInline;
